import styled from "styled-components"

/**
 * Text content to limit maximum width on bigger screen/media.
 */
export const Content = styled.div`
  max-width: ${({ theme, maxWidth }) => maxWidth / theme.baseSize}rem;
`
